import ExternalLayout from "./ExternalLayout.vue";
export default ExternalLayout;
